import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MarkupType } from "@/model/interface/PricingPlan";
import React from "react";

interface RateFieldProps {
  label: string;
  baseRate: number;
  markupType: MarkupType;
  markupAmount: number;
  onBaseRateChange: (v: number) => void;
  onMarkupTypeChange: (v: MarkupType) => void;
  onMarkupAmountChange: (v: number) => void;
}

export default function RateField({
  label,
  baseRate,
  markupType,
  markupAmount,
  onBaseRateChange,
  onMarkupTypeChange,
  onMarkupAmountChange,
}: RateFieldProps) {
  const effectiveRate =
    markupType === "PERCENTAGE" ? baseRate * (1 + markupAmount / 100) : baseRate + markupAmount;

  return (
    <div className="space-y-1.5">
      <Label className="text-xs font-medium">{label}</Label>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <span className="text-[10px] text-muted-foreground">Base ($)</span>
          <Input
            type="number"
            step="0.0001"
            value={baseRate}
            onChange={(changeEvent) => onBaseRateChange(parseFloat(changeEvent.target.value) || 0)}
          />
        </div>
        <div>
          <span className="text-[10px] text-muted-foreground">Markup</span>
          <div className="flex gap-1">
            <Select
              value={markupType}
              onValueChange={(selectedMarkupType) => onMarkupTypeChange(selectedMarkupType as MarkupType)}
            >
              <SelectTrigger className="w-16 text-xs">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="FLAT">$</SelectItem>
                <SelectItem value="PERCENTAGE">%</SelectItem>
              </SelectContent>
            </Select>
            <Input
              type="number"
              step="0.01"
              value={markupAmount}
              onChange={(changeEvent) => onMarkupAmountChange(parseFloat(changeEvent.target.value) || 0)}
            />
          </div>
        </div>
        <div>
          <span className="text-[10px] text-muted-foreground">Effective</span>
          <div className="h-9 flex items-center text-sm font-mono">${effectiveRate.toFixed(4)}</div>
        </div>
      </div>
    </div>
  );
}
